// class for AddTaskComponent route parameters
export class AddTaskQueryParam {
  returnUrl : string;
  mode : string;
  dailyTypeId: number;
  placeTypeCode: string; // P public area  R Room
  placeNumber: string;  // RoomNumber or AreaCode 
  placeCode: string; // P public area  R Room
}
